import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import './index.less';
import FaeHeader from '@/pages/TechnicalSupport/components/FaeHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Form, Input } from 'antd';
import FormItems from '@/components/FormItems';
import { FormItem, UploadFileStatus } from '@/types/base';
import moment from 'moment';
import RichText from '@/components/RichText';
import { getFAEOrderCategory, getFAEOrderDetail, getFAEProjectDetail, submitFAEOrder, updateFAEOrder } from '@/api/technical';
import { formListLeft, formListRight } from './config';
import dayjs from 'dayjs';
import UploadFile from '@/components/UploadFile';
import { FAEOrderStatus } from '@/types/technical';

const initFileValue = -1;
const prefix = 'submit-order';
const SubmitOrder: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  const searchParams = useRef<any>(new URLSearchParams(location.search));
  const id = searchParams.current.get('id');
  const isEdit = searchParams.current.get('type') == 'edit'; //当前模式
  const uploadRef = useRef<any>(null);
  const formItemsLeft = useRef<FormItem[]>(formListLeft);
  const formItemsRight = useRef<FormItem[]>(formListRight);
  const [isRichText, setIsRichText] = useState(false);
  const [isCategoryChange, setIsCategoryChange] = useState(false);
  const initFileList = useRef<any>(isEdit ? initFileValue : []);
  const orderDetail = useRef<any>(null);//工单详情
  const richTextShow = isEdit ? isRichText : true; //是否显示富文本
  const uploadFileShow = isEdit ? !(initFileList.current == initFileValue) : true; //是否显示上传文件
  const [isOrderPermission, setIsOrderPermission] = useState<boolean>(false);//工单权限
  const [loading, setLoading] = useState(true);//提交loading
  const isOrderCanEdit = isEdit ? orderDetail.current?.status == FAEOrderStatus.WAIT_AUDIT : true;//工单是否可编辑
  const noPermissionTip='您的FAE项目已过期/已禁用，请联系您的生态经理';
  console.log('SubmitOrder render', isRichText, orderDetail.current?.status);
  const backClick = useCallback(() => {
    navigate('/technicalSupport/fae/order');
  }, []);
  const onSubmit = useCallback(
    /**
     * 提交表单
     * @param values 
     * @returns 
     */
    (values: any) => {
      console.log(values);
      const uploadFiles = uploadRef.current?.getFiles().filter((v: any) => v.status);
      console.log('onSubmit uploadFiles', uploadFiles);
      if (uploadFiles.some((v: any) => v.status == UploadFileStatus.UPLOADING)) {
        window.message.warning('请等待文件上传完成');
        return;
      }
      const projectId = form.getFieldValue('project_id');
      const enableFlag=form.getFieldValue('projectEnableFlag');
      if (!enableFlag) {
        window.message.warning(noPermissionTip);
        return;
      }
      setLoading(true);
      const params = {
        ...values,
        priority: values.priority?.[0],
        projectProgress: values.projectProgress?.[0],
        questionType: values.questionType?.[0],
        planCompleteTime: new Date(values.planCompleteTime).getTime(),
        proposeTime: new Date(values.proposeTime).getTime(),
        fileIds: uploadFiles.map((item: any) => item.fileId),
        projectId: projectId
      }
      if (isEdit) {
        //修改工单 需要sn号
        params.sn = orderDetail.current?.sn;
        params.id = orderDetail.current?.id;
      }
      const submit = isEdit ? updateFAEOrder : submitFAEOrder;
      const tipText = isEdit ? '修改' : '提交';
      submit(params).then(res => {
        console.log(res);
        if (res.code == 200) {
          window.message.success(tipText + '成功');
          setTimeout(() => {
            backClick();
          }, 1500);
        } else {
          window.message.error(res.message || tipText + '失败');
        }
      }).catch((err) => {
        console.log(err);
       err?.message && window.message.error(err.message || tipText + '失败');
      }).finally(() => {
        setLoading(false);
      })
    }, [])

  console.log('submit-order render ', formItemsLeft.current);

  const getDetail = useCallback(
    /**
     * 获取编辑的 项目工单详情
     * @param id fae id
     */
    (id: any) => {
      getFAEOrderDetail(id).then(res => {
        console.log(res);
        if (res.code == 200) {
          form.setFieldsValue({
            ...res.result,
            project_id: res.result?.projectId,
            priority: [res.result?.priority],
            projectProgress: [res.result?.projectProgress],
            questionType: [res.result?.questionType],
            planCompleteTime: dayjs(new Date(res.result?.planCompleteTime)),
            proposeTime: moment(new Date(res.result?.proposeTime)).format('YYYY-MM-DD HH:mm:ss'),
          });
          orderDetail.current = res.result;//保存详情
          initFileList.current = res.result?.fileList.map((item: any) => {
            return {
              ...item,
              size: Number(item.fileSize),
              uid: item.id,
              status: UploadFileStatus.DONE,
              fileId: item.id,
            }
          });// 获取文件列表
          setIsRichText(true);
        }
      }).catch((err) => {
        console.error(err)
      })
    }, [])

  const getProject = useCallback(
    /**
     * 获取项目详情
     */
    () => {
      getFAEProjectDetail().then(res => {
        console.log('getProject', res);
        if (res.code == 200) {
          form.setFieldsValue({
            projectName: res.result?.projectName || '',
            project_id: res.result?.id,
            projectEnableFlag:res.result?.enableFlag
          });
          if (!res.result?.enableFlag) {
            window.message.warning(noPermissionTip);
            return;
          }
          setIsOrderPermission(true);
        }
      }).catch((err) => {
        console.error(err)
      })
    }, [])
  const onDesChange = useCallback(
    /**
     * 富文本描述改变
     * @param data 
     */
    (data: any) => {
      console.log('onDesChange', data)
      form.setFieldsValue({
        description: data,
      })
    }, [])

  const getCategory = useCallback(
    /**
     * 获取 项目进度和问题领域的分类
     */
    () => {
      console.log('getCategory');
      Promise.all([getFAEOrderCategory('progress'), getFAEOrderCategory('area')]).then((res: any) => {
        // if(res?.code==200){
        console.log('getCategory', res);
        // }
        const categoryList: any[] = []
        res.forEach((item: any, index: number) => {
          if (item?.code == 200 && item?.result?.length) {
            categoryList.push(...item.result)
          }
        });
        formItemsLeft.current[2].options = categoryList.filter((item: any) => item.type == 'area').map((item: any) => {
          return {
            label: item.name,
            value: item.name,
          }
        });
        formItemsRight.current[0].options = categoryList.filter((item: any) => item.type == 'progress').map((item: any) => {
          return {
            label: item.name,
            value: item.name,
          }
        });
        setLoading(false);
        setIsCategoryChange(true);
      })
    }, [])
  const init = useCallback(async () => {

    await getCategory();
    await getProject();
    if (isEdit) {
      //重新编辑
      if (id) {
        //查询详情
        getDetail(id);
      }
    } else {
      //新建
      //设置提出时间默认值
      //查询项目信息
      
      form.setFieldsValue({
        proposeTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      })
    }
  }, [])
  useEffect(() => {
    return () => {
      form.resetFields();
    }
  }, [])
  useLayoutEffect(() => {
    init();
  }, [])
  return (
    <div className={`${prefix} main-wrapper common-antd-form`}>
      <FaeHeader title="我要提单" backClick={backClick} />

      {
          <div className={`${prefix}-content card-bg ${isOrderPermission ? '' : 'common-mask'}`} >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <div className={`${prefix}-content-form-flex-box`}>
              <div>
                <FormItems formItems={formItemsLeft.current} isChange={isCategoryChange} />
              </div>
              <div>
                <FormItems formItems={formItemsRight.current} isChange={isCategoryChange} />
              </div>
            </div>
            <Form.Item label="工单概述" required name="title" rules={[{ required: true, message: '请输入工单概述' },
            {
              max: 255,
              message: "最大输入255个字符",
            }
            ]}>
              <Input placeholder='在xx硬件xx软件版本的情况下，做了xx操作，得到了xx错误结果' />
            </Form.Item>
            {
              richTextShow && <Form.Item
                label="工单描述"
                rules={[
                  {
                    required: true,
                    message: "请输入工单描述",
                  },
                  {
                    max: 12000,
                    message: "最大输入12000个字符",
                  }
                ]}
                name="description"
              >
                <RichText
                  onDataChange={onDesChange}
                  data={form.getFieldValue('description')}
                  height={'20rem'}
                  isCanUploadImage={isOrderCanEdit}
                />
              </Form.Item>
            }
            <div className={`${prefix}-content-form-flex-box`}>
              <div>
                {
                 isOrderPermission && uploadFileShow && <Form.Item label="附件上传" name="fileIds" >
                    <UploadFile
                      ref={uploadRef}
                      isCanUpload={isOrderCanEdit}
                      initFile={initFileList.current}
                      fileConfig={{
                        accept: '.png,.pdf,.zip,.doc,.docx',
                        multiple: true,
                      }}
                    />
                  </Form.Item>
                }
              </div>
              <div>
              </div>
            </div>
            <div className="questions-right-search-btn" style={{ justifyContent: "flex-end" }}>
              <Button onClick={backClick}>取消</Button>
              <Button type="primary" htmlType="submit" disabled={!isOrderPermission || !isOrderCanEdit} loading={loading}>确定</Button>
            </div>
          </Form>
        </div>
      }



    </div>
  );
};

export default SubmitOrder;
